import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';

import HistoryRow from './row';

import './history.scss';

const CLASS_NAME = 'history';

const getDateSection = date => {
  if (moment().isSame(date, 'day')) {
    return 'Today';
  }

  return date ? date.format('ddd MMM DD') : '';
};

const renderHistoryRow = date => (element, indexElement) => {
  const dateString = date.format('DD-MM-YY');
  const index = `${dateString}-${indexElement}`;
  return <HistoryRow key={index} index={index} history={element} />;
};

const renderItems = (date, items) =>
  !_.isEmpty(items) && (
    <>
      <p className={`${CLASS_NAME}__date-section`}>{getDateSection(date)}</p>
      <div className={`${CLASS_NAME}__items`}>{_.map(items, renderHistoryRow(date))}</div>
    </>
  );

class History extends PureComponent {
  renderHistory() {
    const { history } = this.props;
    return _.map(history, (historyItem, index) => (
      <div className="history" key={`history-${index}`}>
        {renderItems(_.get(historyItem, 'date'), _.get(historyItem, 'elements'))}
      </div>
    ));
  }

  render() {
    return <div className={`${CLASS_NAME} style-guide`}>{this.renderHistory()}</div>;
  }
}

History.propTypes = {
  history: PropTypes.arrayOf(
    PropTypes.shape({
      action_at: PropTypes.string,
      text: PropTypes.string,
    }),
  ),
};

export default History;
